import { FormEvent } from "react"
import { Head, useForm, usePage } from "@inertiajs/react"
import { useIntl } from "react-intl"
import { AuthShell } from "@/components/AuthShell"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

import type { PageProps } from "@/types/inertia"

type Props = { token: string }

export default function PasswordEdit({ token }: Props) {
  const intl = useIntl()
  const { props } = usePage<PageProps<Props>>()
  const form = useForm({ password: "" })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.patch(`/passwords/${token}`)
  }

  const errors = props.errors ?? {}
  const title = intl.formatMessage({ id: "auth.password_edit.title" })
  const description = intl.formatMessage({ id: "auth.password_edit.description" })

  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Head>
      <AuthShell>
        <h2 className="text-2xl">{title}</h2>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="space-y-2">
            <label htmlFor="password">{intl.formatMessage({ id: "auth.password_edit.new_password" })}</label>
            <Input
              id="password"
              type="password"
              autoComplete="new-password"
              required
              aria-invalid={!!errors.password}
              value={form.data.password}
              onChange={(e) => form.setData("password", e.target.value)}
            />
            {errors.password && (
              <p className="text-xs text-danger-display">{errors.password}</p>
            )}
          </div>
          <Button type="submit" disabled={form.processing}>
            {intl.formatMessage({ id: "auth.password_edit.submit" })}
          </Button>
        </form>
      </AuthShell>
    </>
  )
}
